<template>
  <fragment>
    <div class="dropdown-w" v-show="false">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedCompaniesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!companies?.length"
                    @active-change="onDropdownActiveChange" @change="onCompanyChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.CompanyPlaceholder`) }} ({{ usedSelectedCompaniesIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="companiesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="company in companiesFiltered" :key="company.Id" :value="company.Id" aria-role="listitem">
            <b-checkbox size="is-small" :value="isCompanySelected(company.Id)" disabled></b-checkbox>
            <span>{{ company.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Company`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="showCommitments">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedCommitmentsIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!commitments?.length"
                    @active-change="onDropdownActiveChange" @change="onCommitmentsChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.ProjectPerformancePlaceholder`) }} ({{ usedSelectedCommitmentsIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="commitmentsSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="commitment in commitmentsFiltered" :key="commitment.Id" :value="commitment.Id" aria-role="listitem">
            <b-checkbox size="is-small" :value="isCommitmentSelected(commitment.Id)" disabled></b-checkbox>
            <span>{{ commitment.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.ProjectPerformance`) }}</p>
        </template>
      </b-tooltip>
    </div>
    <div class="dropdown-w" v-show="processes?.length > 0">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedProcessesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!processes?.length"
                    @active-change="onDropdownActiveChange" @change="onProcessesChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.ProcessPlaceholder`) }} ({{ usedSelectedProcessesIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="processesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="process in processesFiltered" :key="process.Id" :value="process.Id" aria-role="listitem">
            <b-checkbox size="is-small" :value="isProcessSelected(process.Id)" disabled></b-checkbox>
            <span>{{ process.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Process`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="showChannelMetadataType">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedChannelMetadataTypesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
                    @active-change="onDropdownActiveChange" @change="onChannelMetadataTypesChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.ChannelMetadataPlaceholder`) }} ({{ usedSelectedChannelMetadataTypesIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="channelMetadataTypesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="channelMetadataType in channelMetadataTypesFiltered" :key="+channelMetadataType.Id" :value="+channelMetadataType.Id"
                           aria-role="listitem" class="dropdown-item-with-icon">
            <b-checkbox size="is-small" :value="isChannelMetadataTypeSelected(+channelMetadataType.Id)" disabled :id="'cbChannelMetadataType_' + channelMetadataType.Id"></b-checkbox>
            <span class="icon-w" v-if="getChannelMetadataTypeIconName(channelMetadataType.Id)">
              <img :src="require('@/assets/' + getChannelMetadataTypeIconName(channelMetadataType.Id) + '.png')" />
            </span>
            <span class="text">{{ channelMetadataType.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.ChannelMetadata`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="showChannels">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedChannelsIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!channels?.length"
                    @active-change="onDropdownActiveChange" @change="onChannelsChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.ChannelPlaceholder`) }} ({{ usedSelectedChannelsIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="channelsSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="channel in channelsFiltered" :key="channel.Id" :value="channel.Id" :id="'cbChannel_' + channel.Id"
                           aria-role="listitem" class="dropdown-item-with-icon">
            <b-checkbox size="is-small" :value="isChannelSelected(channel.Id)" disabled></b-checkbox>
            <span class="icon-w" v-if="getChannelMetadataTypeIconName(channel.ChannelType)">
              <img :src="require('@/assets/' + getChannelMetadataTypeIconName(channel.ChannelType) + '.png')" />
            </span>
            <span class="text">{{ channel.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Channel`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedAssetsIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!assets?.length"
                    @active-change="onDropdownActiveChange" @change="onAssetsChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.AssetsFilterPlaceholder`) }} ({{ usedSelectedAssetsIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="assetsSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="asset in assetsFiltered" :key="`${asset.AssetId}_${asset.PhoneId}`" :value="asset.AssetId" aria-role="listitem">
            <b-checkbox size="is-small" :value="isAssetSelected(asset.AssetId)" disabled></b-checkbox>
            <span>{{ asset.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Assets`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w ad-titles-wrapper" v-show="showChannels">
      <b-tooltip position="is-bottom" multilined type="is-dark" style="width: 100%;">
        <b-dropdown :value="usedSelectedAdTitles" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!usedSelectedChannelsIds?.length || !adTitles?.length"
                    @active-change="onDropdownActiveChange" @change="onAdTitlesChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.AdTitleFilterPlaceholder`) }} ({{ usedSelectedAdTitles.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="adTitlesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="(adTitle, index) in adTitlesFiltered" :key="index" :value="getAdTitleId(adTitle)" aria-role="listitem">
            <b-checkbox size="is-small" :value="isAdTitleSelected(getAdTitleId(adTitle))" disabled></b-checkbox>
            <span v-html="adTitle.AdTitle"></span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Title`) }}</p>
        </template>
      </b-tooltip>
      <b-tooltip position="is-bottom" multilined type="is-dark" style="left: 1%; right: 1%;">
        <span class="chart-help">
          <icon-base width="16" height="16" view-box="0 0 16 16" icon-name="chart-pie"><icon-question-circle /></icon-base>
        </span>
        <template #content>
          <p>{{ $t("Leads.AdTitlesTooltip") }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedAdGroupsIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!usedSelectedChannelsIds?.length || !adGroups?.length"
                    @active-change="onDropdownActiveChange" @change="onAdGroupsChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.AdGroupsFilterPlaceholder`) }} ({{ usedSelectedAdGroupsIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item v-for="adGroup in adGroupsFiltered" :key="adGroup.Id" :value="adGroup.Id" aria-role="listitem">
            <b-checkbox size="is-small" :value="isAdGroupSelected(adGroup.Id)" disabled></b-checkbox>
            <span>{{ adGroup.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Group`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="pageKind == LeadsPageKind.Leads">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedLeadStatusesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
                    @active-change="onDropdownActiveChange" @change="onLeadStatusesChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.ClientStageOnCreate`) }} ({{ usedSelectedLeadStatusesIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item v-for="leadStatus in leadStatusesFiltered" :key="leadStatus.Id" :value="leadStatus.Id" aria-role="listitem">
            <b-checkbox size="is-small" :value="isLeadStatusSelected(leadStatus.Id)" disabled></b-checkbox>
            <span>{{ leadStatus.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.LeadStatus`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedCallStatusesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
                    @active-change="onDropdownActiveChange">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.LeadType`) }} ({{ usedSelectedCallStatusesIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item v-for="callStatus in callStatuses" :key="+callStatus.Id" :value="+callStatus.Id" aria-role="listitem" @click="onCallStatusesChange(+callStatus.Id)">
            <b-checkbox size="is-small" :value="isCallStatusSelected(+callStatus.Id)" disabled></b-checkbox>
            <span>{{ callStatus.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.LeadType`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="showTags">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedTags" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
                    @active-change="onDropdownActiveChange" @change="onTagsChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.Tag`) }} ({{ usedSelectedTags.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="tagsSearch" class="search" :placeholder="$t('Leads.Tag')" expanded @keydown.native="onTagKeydown($event)" />
          </b-dropdown-item>
          <b-dropdown-item v-for="tag in tagsFiltered" :key="tag.Id" :value="tag.Id" aria-role="listitem">
            <b-checkbox size="is-small" :value="isTagSelected(tag.Id)" disabled></b-checkbox>
            <span>{{ tag.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Tag`) }}</p>
        </template>
      </b-tooltip>
    </div>


    <div class="dropdown-w" v-show="pageKind">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedSaleStatusesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
                    @active-change="onDropdownActiveChange" @change="onSaleStatusesChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t("Leads.SaleStatus") }} ({{ usedSelectedSaleStatusesIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item v-for="saleStatus in saleStatusesFiltered" :key="+saleStatus.Id" :value="+saleStatus.Id" aria-role="listitem">
            <b-checkbox size="is-small" :value="isSaleStatusSelected(+saleStatus.Id)" disabled></b-checkbox>
            <span>{{ saleStatus.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t("Leads.Tooltips.Filters.SaleStatus") }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="pageKind">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown
            :value="usedSelectedAdditionalStatusesIds"
            multiple
            scrollable
            aria-role="list"
            class="multiple custom-checkboxes"
            :disabled="!usedSelectedCompaniesIds?.length || !additionalStatuses?.length"
            @active-change="onDropdownActiveChange"
            @change="onAdditionalStatusesChange($event)"
        >
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.AdditionalStatus`) }} ({{ usedSelectedAdditionalStatusesIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="additionalStatusesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="additionalStatus in additionalStatusesFiltered" :key="+additionalStatus.Value" :value="+additionalStatus.Value" aria-role="listitem">
            <b-checkbox size="is-small" :value="isAdditionalStatusSelected(+additionalStatus.Value)" disabled></b-checkbox>
            <span>{{ additionalStatus.Text }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.AdditionalStatus`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="showPrice">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedPriceType" aria-role="list" class="custom-checkboxes"
                    @active-change="onDropdownActiveChange" @change="onPriceTypeChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`Enums.LeadPriceType.${LeadPriceType[usedSelectedPriceType]}`).toString() }}</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item v-for="priceType in priceTypes" :key="priceType.Id" :value="priceType.Id" aria-role="listitem">
            <b-checkbox size="is-small" :value="isPriceTypeSelected(priceType.Id)" disabled></b-checkbox>
            <span>{{ priceType.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t("Leads.Tooltips.Filters.LeadPriceType") }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="showAssignee">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedAssigneesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
                    :disabled="!usedSelectedCompaniesIds?.length || !assignees?.length"
                    @active-change="onDropdownActiveChange" @change="onAssigneesChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.Assignee`) }} ({{ usedSelectedAssigneesIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="assigneesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="assignee in assigneesFiltered" :key="assignee.SalesmanID" :value="assignee.SalesmanID" aria-role="listitem">
            <b-checkbox size="is-small" :value="isAssigneeSelected(assignee.SalesmanID)" disabled></b-checkbox>
            <span>{{ assignee.SalesmanName }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Assignee`) }}</p>
        </template>
      </b-tooltip>
    </div>
  </fragment>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import VueCookies from "vue-cookies";
import Fragment from "vue-fragment";
import { AvailableChannelMetadataTypesMode, ChannelType } from "@/models/campaigns/ChannelType";
import { ClientProject } from "@/models/ClientProject";
import { LeadsPageKind } from "@/models/LeadsPageKind";
import { LeadsPageViewModel, RefreshGridMode } from "@/models/leads/Lead";
import { CompanyPermission, LeadPermissionType } from "@/models/leads/CompanyPermission";
import { LeadPriceType } from "@/models/leads/LeadPriceType";
import { LeadStatus } from "@/models/leads/LeadStatus";
import { AdTitlesByLeads, Assignee, ChannelMultiselectItem, MultiselectItem, SelectListItem } from "@/models/MultiselectItem";
import { CommonMultiselectPayload } from "@/services/api/ApiService";
import CampaignService from "@/services/CampaignService";
import HelperService from "@/services/HelperService";
import LeadService from "@/services/LeadService";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import IconQuestionCircle from "../icons/IconQuestionCircle.vue";
import i18n from "../../i18n";

Vue.use(Fragment.Plugin);
Vue.use(VueCookies);
const namespace = "leadsModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
    IconQuestionCircle,
  },
})
export default class LeadsFiltersDropdowns extends Vue {
  @Prop({ required: true }) readonly kindPrefix!: string;
  @Prop({ required: true }) readonly pageKind!: LeadsPageKind;


  //#region Vuex getters and actions

  @Getter("adGroups", { namespace }) adGroups!: MultiselectItem[];
  @Getter("adTitles", { namespace }) adTitles!: AdTitlesByLeads[];
  @Getter("additionalStatuses", { namespace }) additionalStatuses!: SelectListItem[];
  @Getter("assets", { namespace }) assets!: ClientProject[];
  @Getter("assignees", { namespace }) assignees!: Assignee[];
  @Getter("channels", { namespace }) channels!: ChannelMultiselectItem[];
  @Getter("companies", { namespace }) companies!: MultiselectItem[];
  @Getter("commitments", { namespace }) commitments!: MultiselectItem[];
  @Getter("processes", { namespace }) processes!: MultiselectItem[];
  @Getter("clientsSelectedAdditionalStatusesIds", { namespace }) clientsSelectedAdditionalStatusesIds!: number[];
  @Getter("clientsSelectedAdGroupsIds", { namespace }) clientsSelectedAdGroupsIds!: string[];
  @Getter("clientsSelectedAdTitles", { namespace }) clientsSelectedAdTitles!: string[];
  @Getter("clientsSelectedAssetsIds", { namespace }) clientsSelectedAssetsIds!: string[];
  @Getter("clientsSelectedAssigneesIds", { namespace }) clientsSelectedAssigneesIds!: number[];
  @Getter("clientsSelectedCallStatusesIds", { namespace }) clientsSelectedCallStatusesIds!: number[];
  @Getter("clientsSelectedChannelMetadataTypesIds", { namespace }) clientsSelectedChannelMetadataTypesIds!: number[];
  @Getter("clientsSelectedChannelsIds", { namespace }) clientsSelectedChannelsIds!: number[];
  @Getter("clientsSelectedCompaniesIds", { namespace }) clientsSelectedCompaniesIds!: number[];
  @Getter("clientsSelectedCommitmentsIds", { namespace }) clientsSelectedCommitmentsIds!: number[];
  @Getter("clientsSelectedProcessesIds", { namespace }) clientsSelectedProcessesIds!: number[];
  @Getter("clientsSelectedFoundMetadataTypesIds", { namespace }) clientsSelectedFoundMetadataTypesIds!: number[];
  @Getter("clientsSelectedLeadStatusesIds", { namespace }) clientsSelectedLeadStatusesIds!: LeadStatus[];
  @Getter("clientsSelectedPriceType", { namespace }) clientsSelectedPriceType!: string;
  @Getter("clientsSelectedSaleStatusesIds", { namespace }) clientsSelectedSaleStatusesIds!: LeadStatus[];
  @Getter("clientsSelectedTags", { namespace }) clientsSelectedTags!: string[];
  @Getter("leadsPageData", { namespace }) leadsPageData!: LeadsPageViewModel;
  @Getter("selectedAdditionalStatusesIds", { namespace }) selectedAdditionalStatusesIds!: number[];
  @Getter("selectedAdGroupsIds", { namespace }) selectedAdGroupsIds!: string[];
  @Getter("selectedAdTitles", { namespace }) selectedAdTitles!: string[];
  @Getter("selectedAssetsIds", { namespace }) selectedAssetsIds!: string[];
  @Getter("selectedAssigneesIds", { namespace }) selectedAssigneesIds!: number[];
  @Getter("selectedCallStatusesIds", { namespace }) selectedCallStatusesIds!: number[];
  @Getter("selectedChannelMetadataTypesIds", { namespace }) selectedChannelMetadataTypesIds!: number[];
  @Getter("selectedChannelsIds", { namespace }) selectedChannelsIds!: number[];
  @Getter("selectedCompaniesIds", { namespace }) selectedCompaniesIds!: number[];
  @Getter("selectedCommitmentsIds", { namespace }) selectedCommitmentsIds!: number[];
  @Getter("selectedProcessesIds", { namespace }) selectedProcessesIds!: number[];
  @Getter("selectedFoundMetadataTypesIds", { namespace }) selectedFoundMetadataTypesIds!: number[];
  @Getter("selectedLeadStatusesIds", { namespace }) selectedLeadStatusesIds!: LeadStatus[];
  @Getter("selectedPriceType", { namespace }) selectedPriceType!: string;
  @Getter("selectedSaleStatusesIds", { namespace }) selectedSaleStatusesIds!: LeadStatus[];
  @Getter("selectedTags", { namespace }) selectedTags!: string[];
  @Getter("showNotActiveCampaign", { namespace }) showNotActiveCampaign!: boolean;
  @Getter("showNotActiveCampaignClientLeads", { namespace }) showNotActiveCampaignClientLeads!: boolean;
  @Getter("tags", { namespace }) tags!: MultiselectItem[];
  @Action("clearAdditionalStatuses", { namespace }) clearAdditionalStatuses!: () => void;
  @Action("clearCommitments", { namespace }) clearCommitments!: () => void;
  @Action("clearProcesses", { namespace }) clearProcesses!: () => void;
  @Action("getProcesses", { namespace }) getProcesses!: (companyId: number) => Promise<MultiselectItem[]>;
  @Action("getAdditionalStatuses", { namespace }) getAdditionalStatuses!: (payload: CommonMultiselectPayload) => Promise<SelectListItem[]>;
  @Action("getAdGroups", { namespace }) getAdGroups!: (payload: CommonMultiselectPayload) => Promise<MultiselectItem[]>;
  @Action("getAdTitles", { namespace }) getAdTitles!: (payload: CommonMultiselectPayload) => Promise<AdTitlesByLeads[]>;
  @Action("getAssets", { namespace }) getAssets!: (payload: CommonMultiselectPayload) => Promise<ClientProject[]>;
  @Action("getAssignees", { namespace }) getAssignees!: (payload: CommonMultiselectPayload) => Promise<Assignee[]>;
  @Action("getChannels", { namespace }) getChannels!: (payload: CommonMultiselectPayload) => Promise<ChannelMultiselectItem[]>;
  @Action("getCommitments", { namespace }) getCommitments!: (payload: CommonMultiselectPayload) => Promise<MultiselectItem[]>;
  @Action("getTags", { namespace }) getTags!: (payload: CommonMultiselectPayload) => Promise<MultiselectItem[]>;
  @Action("setAssets", { namespace }) setAssets!: (assets: ClientProject[]) => void;
  @Action("setAssignees", { namespace }) setAssignees!: (assignees: Assignee[]) => void;
  @Action("setClientsSelectedAdditionalStatusesIds", { namespace }) setClientsSelectedAdditionalStatusesIds!: (selectedAdditionalStatusesIds: number[]) => void;
  @Action("setClientsSelectedAdGroupsIds", { namespace }) setClientsSelectedAdGroupsIds!: (selectedAdGroupsIds: string[]) => void;
  @Action("setClientsSelectedAdTitles", { namespace }) setClientsSelectedAdTitles!: (selectedAdTitles: string[]) => void;
  @Action("setClientsSelectedAssetsIds", { namespace }) setClientsSelectedAssetsIds!: (selectedAssetsIds: string[]) => void;
  @Action("setClientsSelectedAssigneesIds", { namespace }) setClientsSelectedAssigneesIds!: (selectedAssigneesIds: number[]) => void;
  @Action("setClientsSelectedCallStatusesIds", { namespace }) setClientsSelectedCallStatusesIds!: (selectedCallStatusesIds: number[]) => void;
  @Action("setClientsSelectedChannelsIds", { namespace }) setClientsSelectedChannelsIds!: (selectedChannelsIds: number[]) => void;
  @Action("setClientsSelectedChannelMetadataTypesIds", { namespace }) setClientsSelectedChannelMetadataTypesIds!: (selectedChannelMetadataTypesIds: number[]) => void;
  @Action("setClientsSelectedCompaniesIds", { namespace }) setClientsSelectedCompaniesIds!: (selectedCompaniesIds: number[]) => void;
  @Action("setClientsSelectedCommitmentsIds", { namespace }) setClientsSelectedCommitmentsIds!: (selectedCommitmentsIds: number[]) => void;
  @Action("setClientsSelectedProcessesIds", { namespace }) setClientsSelectedProcessesIds!: (selectedProcessesIds: number[]) => void;
  @Action("setClientsSelectedLeadStatusesIds", { namespace }) setClientsSelectedLeadStatusesIds!: (selectedLeadStatusesIds: LeadStatus[]) => void;
  @Action("setClientsSelectedPriceType", { namespace }) setClientsSelectedPriceType!: (selectedPriceType: string) => void;
  @Action("setClientsSelectedSaleStatusesIds", { namespace }) setClientsSelectedSaleStatusesIds!: (selectedSaleStatusesIds: LeadStatus[]) => void;
  @Action("setClientsSelectedTags", { namespace }) setClientsSelectedTags!: (selectedTags: string[]) => void;
  @Action("setNeedToRefreshLeadsGrid", { namespace }) setNeedToRefreshLeadsGrid!: (needToRefreshLeadsGrid: RefreshGridMode) => void;
  @Action("setSelectedAdditionalStatusesIds", { namespace }) setSelectedAdditionalStatusesIds!: (selectedAdditionalStatusesIds: number[]) => void;
  @Action("setSelectedAdGroupsIds", { namespace }) setSelectedAdGroupsIds!: (selectedAdGroupsIds: string[]) => void;
  @Action("setSelectedAdTitles", { namespace }) setSelectedAdTitles!: (selectedAdTitles: string[]) => void;
  @Action("setSelectedAssetsIds", { namespace }) setSelectedAssetsIds!: (selectedAssetsIds: string[]) => void;
  @Action("setSelectedAssigneesIds", { namespace }) setSelectedAssigneesIds!: (selectedAssigneesIds: number[]) => void;
  @Action("setSelectedCallStatusesIds", { namespace }) setSelectedCallStatusesIds!: (selectedCallStatusesIds: number[]) => void;
  @Action("setSelectedChannelMetadataTypesIds", { namespace }) setSelectedChannelMetadataTypesIds!: (selectedChannelMetadataTypesIds: number[]) => void;
  @Action("setSelectedChannelsIds", { namespace }) setSelectedChannelsIds!: (selectedChannelsIds: number[]) => void;
  @Action("setSelectedCompaniesIds", { namespace }) setSelectedCompaniesIds!: (selectedCompaniesIds: number[]) => void;
  @Action("setSelectedCommitmentsIds", { namespace }) setSelectedCommitmentsIds!: (selectedCommitmentsIds: number[]) => void;
  @Action("setSelectedProcessesIds", { namespace }) setSelectedProcessesIds!: (selectedProcessesIds: number[]) => void;
  @Action("setSelectedLeadStatusesIds", { namespace }) setSelectedLeadStatusesIds!: (selectedLeadStatusesIds: LeadStatus[]) => void;
  @Action("setSelectedPriceType", { namespace }) setSelectedPriceType!: (selectedPriceType: string) => void;
  @Action("setSelectedSaleStatusesIds", { namespace }) setSelectedSaleStatusesIds!: (selectedSaleStatusesIds: LeadStatus[]) => void;
  @Action("setSelectedTags", { namespace }) setSelectedTags!: (selectedTags: string[]) => void;
  @Action("setTags", { namespace }) setTags!: (tags: MultiselectItem[]) => void;

  //#endregion Vuex getters and actions


  //#region Properties

  LeadsPageKind = LeadsPageKind;
  LeadPriceType = LeadPriceType;

  adGroupsSearch = "";
  adTitlesSearch = "";
  additionalStatusesSearch = "";
  assetsSearch = "";
  assigneesSearch = "";
  channelMetadataTypesSearch = "";
  channelsSearch = "";
  companiesSearch = "";
  commitmentsSearch = "";
  processesSearch = "";
  leadStatusesSearch = "";
  saleStatusesSearch = "";
  tagsSearch = "";

  //#endregion Properties


  //#region Watchers

  @Watch("pageKind", { immediate: true })
  onPageKindChange(newValue: LeadsPageKind, oldValue: LeadsPageKind): void {
    if (oldValue === undefined) return;
    if (newValue === undefined) return;

    if (this.usedSelectedCompaniesIds.length > 0) {
      this.getChannels(this.commonPayload);
    }
  }

  @Watch("clientsSelectedAdditionalStatusesIds", { immediate: true })
  @Watch("selectedAdditionalStatusesIds", { immediate: true })
  onSelectedAdditionalStatusesIdsChange(newSelectedAdditionalStatusesIds: number[], oldSelectedAdditionalStatusesIds: number[]): void {
    if (oldSelectedAdditionalStatusesIds === undefined || newSelectedAdditionalStatusesIds.length === oldSelectedAdditionalStatusesIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedAdGroupsIds", { immediate: true })
  @Watch("selectedAdGroupsIds", { immediate: true })
  onSelectedAdGroupsIdsChange(newSelectedAdGroupsIds: string[], oldSelectedAdGroupsIds: string[]): void {
    if (oldSelectedAdGroupsIds === undefined || newSelectedAdGroupsIds.length === oldSelectedAdGroupsIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedAdTitles", { immediate: true })
  @Watch("selectedAdTitles", { immediate: true })
  onSelectedAdTitlesChange(newSelectedAdTitles: string[], oldSelectedAdTitles: string[]): void {
    if (oldSelectedAdTitles === undefined || newSelectedAdTitles.length === oldSelectedAdTitles.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedAssetsIds", { immediate: true })
  @Watch("selectedAssetsIds", { immediate: true })
  onSelectedAssetsIdsChange(newSelectedAssetsIds: string[], oldSelectedAssetsIds: string[]): void {
    if (oldSelectedAssetsIds === undefined || newSelectedAssetsIds.length === oldSelectedAssetsIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedAssigneesIds", { immediate: true })
  @Watch("selectedAssigneesIds", { immediate: true })
  onSelectedAssigneesIdsChange(newSelectedAssigneesIds: number[], oldSelectedAssigneesIds: number[]): void {
    if (oldSelectedAssigneesIds === undefined || newSelectedAssigneesIds.length === oldSelectedAssigneesIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedCallStatusesIds", { immediate: true })
  @Watch("selectedCallStatusesIds", { immediate: true })
  onSelectedCallStatusesIdsChange(newSelectedCallStatusesIds: number[], oldSelectedCallStatusesIds: number[]): void {
    if (oldSelectedCallStatusesIds === undefined || newSelectedCallStatusesIds.length === oldSelectedCallStatusesIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedChannelMetadataTypesIds", { immediate: true })
  @Watch("selectedChannelMetadataTypesIds", { immediate: true })
  onSelectedChannelMetadataTypesIdsChange(newSelectedChannelMetadataTypesIds: number[], oldSelectedChannelMetadataTypesIds: number[]): void {
    if (oldSelectedChannelMetadataTypesIds === undefined || newSelectedChannelMetadataTypesIds.length === oldSelectedChannelMetadataTypesIds.length) {
      return;
    } else {
      if (this.usedSelectedCompaniesIds.length > 0) {
        this.getChannels(this.commonPayload);
      }
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedChannelsIds", { immediate: true })
  @Watch("selectedChannelsIds", { immediate: true })
  onSelectedChannelsIdsChange(newSelectedChannelsIds: number[], oldSelectedChannelsIds: number[]): void {
    if (oldSelectedChannelsIds === undefined || newSelectedChannelsIds.length === oldSelectedChannelsIds.length) {
      return;
    } else {
      this.getAdTitles(this.commonPayload).then((adTitles: AdTitlesByLeads[]) => {
        if (this.$route.query.adGroups) {
          this.setUsedSelectedAdGroupsIds((this.$route.query.adGroups as string).split(","));
        }
        if (this.$route.query.adTitles) {
          this.setUsedSelectedAdTitles((this.$route.query.adTitles as string).split(","));
        }
      });
      this.getAdGroups(this.commonPayload);
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedCompaniesIds", { immediate: true })
  @Watch("selectedCompaniesIds", { immediate: true })
  onSelectedCompaniesIdsChange(newSelectedCompaniesIds: number[], oldSelectedCompaniesIds: number[]): void {
    if (oldSelectedCompaniesIds === undefined) {
      return;
    } else {
      this.setUsedSelectedChannelsIds([]);
      if (this.usedSelectedCompaniesIds.length > 0) {
        this.getChannels(this.commonPayload);
      }
      this.setUsedSelectedAssetsIds([]);
      if (newSelectedCompaniesIds.length > 0) {
        this.getAssets(this.commonPayload).then((assets: ClientProject[]) => {
          if (this.$route.query.assetIds) {
            this.setUsedSelectedAssetsIds((this.$route.query.assetIds as string).split(","));
          }
        });
        this.getAssignees(this.commonPayload).then((assignees: Assignee[]) => {
          if (this.$route.query.assignees) {
            this.setUsedSelectedAssigneesIds((this.$route.query.assignees as string).split(",").map(i => +i));
          }
        });
      } else {
        this.setUsedSelectedAssetsIds([]);
        this.setAssets([]);
        this.setUsedSelectedAssigneesIds([]);
        this.setAssignees([]);
      }
      this.setUsedSelectedCommitmentsIds([]);
      this.getCommitments(this.commonPayload);
      this.setUsedSelectedProcessesIds([]);
      this.clearProcesses();
      if (newSelectedCompaniesIds.length > 0) {
        this.getProcesses(newSelectedCompaniesIds[0]);
      }
      this.setUsedSelectedAdditionalStatusesIds([]);
      this.clearAdditionalStatuses();
      this.getAdditionalStatuses(this.commonPayload).then((statuses: SelectListItem[]) => {
        if (this.$route.query.additionalStatuses) {
          this.setUsedSelectedAdditionalStatusesIds((this.$route.query.additionalStatuses as string).split(",").map(i => +i));
        }
      });
      this.getTags(this.commonPayload);
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedCommitmentsIds", { immediate: true })
  @Watch("selectedCommitmentsIds", { immediate: true })
  onSelectedCommitmentsIdsChange(newSelectedCommitmentsIds: number[], oldSelectedCommitmentsIds: number[]): void {
    if (oldSelectedCommitmentsIds === undefined || newSelectedCommitmentsIds.length === oldSelectedCommitmentsIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedProcessesIds", { immediate: true })
  @Watch("selectedProcessesIds", { immediate: true })
  onSelectedProcessesIdsChange(newSelectedProcessesIds: number[], oldSelectedProcessesIds: number[]): void {
    if (oldSelectedProcessesIds === undefined || newSelectedProcessesIds.length === oldSelectedProcessesIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedFoundMetadataTypesIds", { immediate: true })
  @Watch("selectedFoundMetadataTypesIds", { immediate: true })
  onSelectedFoundMetadataTypesIdsChange(newSelectedFoundMetadataTypesIds: number[], oldSelectedFoundMetadataTypesIds: number[]): void {
    if (oldSelectedFoundMetadataTypesIds === undefined || newSelectedFoundMetadataTypesIds.length === oldSelectedFoundMetadataTypesIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedLeadStatusesIds", { immediate: true })
  @Watch("selectedLeadStatusesIds", { immediate: true })
  onSelectedLeadStatusesIdsChange(newSelectedLeadStatusesIds: LeadStatus[], oldSelectedLeadStatusesIds: LeadStatus[]): void {
    if (oldSelectedLeadStatusesIds === undefined || newSelectedLeadStatusesIds.length === oldSelectedLeadStatusesIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedPriceType", { immediate: true })
  @Watch("selectedPriceType", { immediate: true })
  onSelectedPriceTypeChange(newValue: string, oldValue: string): void {
    if (newValue === oldValue || oldValue === undefined) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedSaleStatusesIds", { immediate: true })
  @Watch("selectedSaleStatusesIds", { immediate: true })
  onSelectedSaleStatusesIdsChange(newSelectedSaleStatusesIds: LeadStatus[], oldSelectedSaleStatusesIds: LeadStatus[]): void {
    if (oldSelectedSaleStatusesIds === undefined || newSelectedSaleStatusesIds.length === oldSelectedSaleStatusesIds.length) {
      return;
    } else {
      this.setUsedSelectedAdditionalStatusesIds([]);
      this.clearAdditionalStatuses();
      this.getAdditionalStatuses(this.commonPayload);
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("clientsSelectedTags", { immediate: true })
  @Watch("selectedTags", { immediate: true })
  onSelectedTagsChange(newSelectedTags: string[], oldSelectedTags: string[]): void {
    if (oldSelectedTags === undefined || newSelectedTags.length === oldSelectedTags.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("showNotActiveCampaign", { immediate: true })
  @Watch("showNotActiveCampaignClientLeads", { immediate: true })
  onShowNotActiveCampaignChange(newShowNotActiveCampaignValue: string, oldShowNotActiveCampaignValue: string): void {
    if (newShowNotActiveCampaignValue === oldShowNotActiveCampaignValue || oldShowNotActiveCampaignValue === undefined) {
      return;
    } else {
      if (this.usedSelectedCompaniesIds.length > 0) {
        this.getChannels(this.commonPayload).then((channels: ChannelMultiselectItem[]) => {
          if (!newShowNotActiveCampaignValue) {
            // filter out selected not active channel channels that not in the new active channels
            const channelsIds: number[] = channels.map(i => parseInt(i.Id));
            const selectedChannelsIdsFiltered: number[] = this.usedSelectedChannelsIds.filter((selectedChannelId: number) => {
              return channelsIds.indexOf(selectedChannelId) >= 0;
            });
            if (selectedChannelsIdsFiltered.length < this.usedSelectedChannelsIds.length) {
              this.setUsedSelectedChannelsIds(selectedChannelsIdsFiltered);
              this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
            }

            this.getAdTitles(this.commonPayload);
            this.getAdGroups(this.commonPayload);
            this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
          }
        });
      }
      this.setUsedSelectedCommitmentsIds([]);
      this.clearCommitments();
      this.getCommitments(this.commonPayload);
    }
  }

  //#endregion Watchers


  //#region Getters

  get adGroupsFiltered(): MultiselectItem[] {
    if (!this.adGroups) {
      return [];
    }

    return this.adGroups.filter((i: MultiselectItem) => i.Title?.toLowerCase().indexOf(this.adGroupsSearch.toLowerCase()) >= 0)
        .sort(HelperService.sortMultiselectItems(this.usedSelectedAdGroupsIds));
  }

  get adTitlesFiltered(): AdTitlesByLeads[] {
    if (!this.adTitles) {
      return [];
    }

    return this.adTitles.filter((i: AdTitlesByLeads) => i.AdTitle?.toLowerCase().indexOf(this.adTitlesSearch.toLowerCase()) >= 0)
        .sort(HelperService.sortAdTitles(this.usedSelectedAdTitles));
  }

  get additionalStatusesFiltered(): SelectListItem[] {
    if (!Array.isArray(this.additionalStatuses)) {
      return [];
    }

    return this.additionalStatuses.filter((i: SelectListItem) => i.Text?.toLowerCase().indexOf(this.additionalStatusesSearch.toLowerCase()) >= 0)
        .sort(HelperService.sortSelectListItems(this.usedSelectedAdditionalStatusesIds));
  }

  get assetsFiltered(): ClientProject[] {
    if (!this.assets) {
      return [];
    }

    return this.assets.filter((i: ClientProject) => i.Title?.toLowerCase().indexOf(this.assetsSearch.toLowerCase()) >= 0)
        .sort(HelperService.sortAssets(this.usedSelectedAssetsIds));
  }

  get assigneesFiltered(): Assignee[] {
    if (!this.assignees) {
      return [];
    }

    return this.assignees.filter((i: Assignee) => i.SalesmanName?.toLowerCase().indexOf(this.assigneesSearch.toLowerCase()) >= 0)
        .sort(HelperService.sortAssignees(this.usedSelectedAssigneesIds));
  }

  get callStatuses(): MultiselectItem[] {
    return LeadService.getCallStatuses();
  }

  get channelMetadataTypesFiltered(): MultiselectItem[] {
    return CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.Leads, this.channelMetadataTypesSearch.toLowerCase())
        .sort(HelperService.sortMultiselectItemsByIds(this.usedSelectedChannelMetadataTypesIds));
  }

  get channelsFiltered(): ChannelMultiselectItem[] {
    if (!this.channels) {
      return [];
    }

    return this.channels.filter((i: ChannelMultiselectItem) => i.Title?.toLowerCase().indexOf(this.channelsSearch.toLowerCase()) >= 0)
        .sort(HelperService.sortMultiselectItemsByIds(this.usedSelectedChannelsIds));
  }

  get companiesFiltered(): MultiselectItem[] {
    if (!this.companies) {
      return [];
    }

    return this.companies.filter((i: MultiselectItem) => i.Title?.toLowerCase().indexOf(this.companiesSearch.toLowerCase()) >= 0)
        .sort(HelperService.sortMultiselectItemsByIds(this.usedSelectedCompaniesIds));
  }

  get commitmentsFiltered(): MultiselectItem[] {
    if (!this.commitments) {
      return [];
    }

    return this.commitments.filter((i: MultiselectItem) => i.Title?.toLowerCase().indexOf(this.commitmentsSearch.toLowerCase()) >= 0)
        .sort(HelperService.sortMultiselectItemsByIds(this.usedSelectedCommitmentsIds));
  }

  get processesFiltered(): MultiselectItem[] {
    if (!this.processes) {
      return [];
    }

    return this.processes.filter((i: MultiselectItem) => i.Title?.toLowerCase().indexOf(this.processesSearch.toLowerCase()) >= 0)
        .sort(HelperService.sortMultiselectItemsByIds(this.usedSelectedProcessesIds));
  }

  get commonPayload(): CommonMultiselectPayload {
    let showNotActiveCamp = this.showNotActiveCampaign;
    if (this.pageKind == LeadsPageKind.Clients) {
      showNotActiveCamp = this.showNotActiveCampaignClientLeads;
    }

    return {
      companyIds: this.usedSelectedCompaniesIds,
      showNotActiveCamp: showNotActiveCamp,
      metadataIds: this.usedSelectedChannelMetadataTypesIds,
      statusIds: this.usedSelectedSaleStatusesIds.map((i: LeadStatus) => i.toString()),
      channelIds: this.usedSelectedChannelsIds,
    };
  }

  get leadStatusesFiltered(): MultiselectItem[] {
    return LeadService.getAvailableLeadStatuses(this.leadStatusesSearch.toLowerCase());
  }

  get priceTypes(): MultiselectItem[] {
    const result: MultiselectItem[] = [];
    const keys: number[] = Object.keys(LeadPriceType)
        .filter((i) => parseInt(i) >= 0)
        .map((i) => parseInt(i));
    for (const key of keys) {
      const title: string = i18n.t(`Enums.LeadPriceType.${LeadPriceType[key]}`).toString();
      if (title.toLowerCase().indexOf(this.channelMetadataTypesSearch.toLowerCase()) >= 0) {
        result.push({
          Id: key.toString(),
          Title: title,
        });
      }
    }
    return result;
  }

  get saleStatusesFiltered(): MultiselectItem[] {
    return LeadService.getAvailableSaleStatuses();
  }

  get showAssignee(): boolean {
    return !!this.pageKind && this.leadsPageData && this.leadsPageData.ShowSalesman;
  }

  get showChannels(): boolean {
    return this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: CompanyPermission) => i.Restriction === LeadPermissionType.Campaigns);
  }

  get showChannelMetadataType(): boolean {
    return this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: CompanyPermission) => i.Restriction === LeadPermissionType.Source);
  }

  get showCommitments(): boolean {
    return this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: CompanyPermission) => i.Restriction === LeadPermissionType.Project);
  }

  get showGraphsPermission(): boolean {
    return this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: CompanyPermission) => i.Restriction === LeadPermissionType.LeadsScreenCharts);
  }

  get showPrice(): boolean {
    return !this.pageKind && this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: CompanyPermission) => i.Restriction === LeadPermissionType.Price);
  }

  get showTags(): boolean {
    return this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: CompanyPermission) => i.Restriction === LeadPermissionType.Tags);
  }

  get tagsFiltered(): MultiselectItem[] {
    if (!this.tags) {
      return [];
    }

    return this.tags.filter((i: MultiselectItem) => !this.tagsSearch || i.Title?.toLowerCase().indexOf(this.tagsSearch.toLowerCase()) >= 0)
        .sort(HelperService.sortMultiselectItems(this.usedSelectedTags));
  }

  //#region Getters based on page kind

  get usedSelectedAdditionalStatusesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedAdditionalStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedAdditionalStatusesIds;
    }
  }

  get usedSelectedAdGroupsIds(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedAdGroupsIds;
      case LeadsPageKind.Leads:
        return this.selectedAdGroupsIds;
    }
  }

  get usedSelectedAdTitles(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedAdTitles;
      case LeadsPageKind.Leads:
        return this.selectedAdTitles;
    }
  }

  get usedSelectedAssetsIds(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedAssetsIds;
      case LeadsPageKind.Leads:
        return this.selectedAssetsIds;
    }
  }

  get usedSelectedAssigneesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedAssigneesIds;
      case LeadsPageKind.Leads:
        return this.selectedAssigneesIds;
    }
  }

  get usedSelectedCallStatusesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedCallStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedCallStatusesIds;
    }
  }

  get usedSelectedChannelMetadataTypesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedChannelMetadataTypesIds;
      case LeadsPageKind.Leads:
        return this.selectedChannelMetadataTypesIds;
    }
  }

  get usedSelectedChannelsIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedChannelsIds;
      case LeadsPageKind.Leads:
        return this.selectedChannelsIds;
    }
  }

  get usedSelectedCompaniesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedCompaniesIds;
      case LeadsPageKind.Leads:
        return this.selectedCompaniesIds;
    }
  }

  get usedSelectedCommitmentsIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedCommitmentsIds;
      case LeadsPageKind.Leads:
        return this.selectedCommitmentsIds;
    }
  }

  get usedSelectedProcessesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedProcessesIds;
      case LeadsPageKind.Leads:
        return this.selectedProcessesIds;
    }
  }

  get usedSelectedFoundMetadataTypesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedFoundMetadataTypesIds;
      case LeadsPageKind.Leads:
        return this.selectedFoundMetadataTypesIds;
    }
  }

  get usedSelectedLeadStatusesIds(): LeadStatus[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedLeadStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedLeadStatusesIds;
    }
  }

  get usedSelectedPriceType(): string {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedPriceType;
      case LeadsPageKind.Leads:
        return this.selectedPriceType;
    }
  }

  get usedSelectedSaleStatusesIds(): LeadStatus[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedSaleStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedSaleStatusesIds;
    }
  }

  get usedSelectedTags(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedTags;
      case LeadsPageKind.Leads:
        return this.selectedTags;
    }
  }

  //#endregion Getters based on page kind

  //#endregion Getters


  //#region Handlers

  onAdGroupsChange(adGroups: string[]): void {
    this.setUsedSelectedAdGroupsIds(adGroups);
  }

  onAdTitlesChange(adTitles: string[]): void {
    this.setUsedSelectedAdTitles(adTitles);
  }

  onAdditionalStatusesChange(additionalStatusesIds: number[]): void {
    this.setUsedSelectedAdditionalStatusesIds(additionalStatusesIds);
  }

  onAssetsChange(assetsIds: string[]): void {
    this.setUsedSelectedAssetsIds(assetsIds);
  }

  onAssigneesChange(assigneesIds: number[]): void {
    this.setUsedSelectedAssigneesIds(assigneesIds);
  }

  onCallStatusesChange(selectedValue: number): void {
    // only if user select new value, not if deselect value
    const allCallsValue = -1;
    const enumValues = [0, 1];
    selectedValue = +selectedValue;
    let values = [...this.usedSelectedCallStatusesIds];
    if (values.indexOf(selectedValue) >= 0) {
      const ind: number = values.indexOf(selectedValue);
      values.splice(ind, 1);
    } else {
      values.push(selectedValue);
      if (selectedValue === allCallsValue) {
        // if user picked 'all calls' remove all enum values
        values = values.filter((i: number) => i < 0);
      } else if (enumValues.indexOf(selectedValue) !== -1) {
        // if user picked one value of enum values,
        // remove 'all calls' if not all enum values picked
        // else - replace enum values with 'all calls'
        let i = 0;
        for (let v of enumValues) {
          if (values.indexOf(v) !== -1) {
            i++;
          }
        }
        if (i === enumValues.length) {
          values = values.filter((i: number) => enumValues.indexOf(i) === -1);
          values.push(allCallsValue);
        } else if (values.indexOf(allCallsValue) !== -1) {
          values = values.filter((i: number) => i !== allCallsValue);
        }
      }
    }
    this.setUsedSelectedCallStatusesIds(values);
  }

  onChannelMetadataTypesChange(channelMetadataTypes: ChannelType[]): void {
    this.setUsedSelectedChannelMetadataTypesIds(channelMetadataTypes);
  }

  onChannelsChange(channelIds: number[]): void {
    this.setUsedSelectedChannelsIds(channelIds);
  }

  onCompanyChange(companyIds: number[]): void {
    this.setUsedSelectedCompaniesIds(companyIds);
  }

  onCommitmentsChange(commitmentsIds: number[]): void {
    this.setUsedSelectedCommitmentsIds(commitmentsIds);
  }

  onProcessesChange(processesIds: number[]): void {
    this.setUsedSelectedProcessesIds(processesIds);
  }

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  onLeadStatusesChange(leadStatuses: LeadStatus[]): void {
    this.setUsedSelectedLeadStatusesIds(leadStatuses);
  }

  onPriceTypeChange(priceTypeId: string): void {
    this.setUsedSelectedPriceType(priceTypeId);
  }

  onSaleStatusesChange(saleStatusesIds: string[]): void {
    this.setUsedSelectedSaleStatusesIds(saleStatusesIds.map((i: string) => +i));
  }

  onTagKeydown(e: KeyboardEvent): void {
    if (e.key !== "Enter") {
      return;
    }
    const tag: string = (e.target as HTMLInputElement).value;
    if (tag === "") {
      return;
    }
    var newItem: MultiselectItem = {
      Id: tag,
      Title: tag,
    };
    let newTags = [...this.tags];
    newTags.push(newItem);
    this.setTags(newTags);

    let newSelectedTags = [...this.usedSelectedTags];
    newSelectedTags.push(tag);
    this.onTagsChange(newSelectedTags);
  }

  onTagsChange(tags: string[]): void {
    this.setUsedSelectedTags(tags);
  }

  //#endregion Handlers


  //#region Private methods

  private getAdTitleId(adTitle: AdTitlesByLeads) {
    return HelperService.getAdTitleId(adTitle);
  }

  private getChannelMetadataTypeIconName(type: string): string {
    return CampaignService.getChannelMetadataTypeIconName(+type);
  }

  //#region Is item selected

  private isAdditionalStatusSelected(additionalStatusId: number) {
    return this.usedSelectedAdditionalStatusesIds.includes(additionalStatusId);
  }

  private isAdGroupSelected(adGroup: string) {
    return this.usedSelectedAdGroupsIds.includes(adGroup);
  }

  private isAdTitleSelected(adTitle: string) {
    return this.usedSelectedAdTitles.includes(adTitle);
  }

  private isAssetSelected(assetId: string) {
    return this.usedSelectedAssetsIds.includes(assetId);
  }

  private isAssigneeSelected(assigneeId: number) {
    return this.usedSelectedAssigneesIds.includes(assigneeId);
  }

  private isCallStatusSelected(callStatus: number) {
    return this.usedSelectedCallStatusesIds.includes(callStatus);
  }

  private isChannelSelected(channelId: number) {
    return this.usedSelectedChannelsIds.includes(channelId);
  }

  private isChannelMetadataTypeSelected(channelMetadataTypeId: number) {
    return this.usedSelectedChannelMetadataTypesIds.includes(channelMetadataTypeId);
  }

  private isCompanySelected(companiesId: number) {
    return this.usedSelectedCompaniesIds.includes(companiesId);
  }

  private isCommitmentSelected(commitmentId: number) {
    return this.usedSelectedCommitmentsIds.includes(commitmentId);
  }

  private isProcessSelected(processId: number) {
    return this.usedSelectedProcessesIds.includes(processId);
  }

  private isLeadStatusSelected(leadStatus: LeadStatus) {
    return this.usedSelectedLeadStatusesIds.includes(leadStatus);
  }

  private isPriceTypeSelected(priceType: string) {
    return this.usedSelectedPriceType === priceType;
  }

  private isSaleStatusSelected(leadStatus: LeadStatus) {
    return this.usedSelectedSaleStatusesIds.includes(leadStatus);
  }

  private isTagSelected(tag: string) {
    return this.usedSelectedTags.includes(tag);
  }

  //#endregion Is item selected

  //#region Setters based on page kind

  setUsedSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds);
        break;
    }
  }

  setUsedSelectedAdGroupsIds(sselectedAdGroupsIds: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedAdGroupsIds(sselectedAdGroupsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAdGroupsIds(sselectedAdGroupsIds);
        break;
    }
  }

  setUsedSelectedAdTitles(selectedAdTitles: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedAdTitles(selectedAdTitles);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAdTitles(selectedAdTitles);
        break;
    }
  }

  setUsedSelectedAssetsIds(selectedAssetsIds: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedAssetsIds(selectedAssetsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAssetsIds(selectedAssetsIds);
        break;
    }
  }

  setUsedSelectedAssigneesIds(selectedAssigneesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedAssigneesIds(selectedAssigneesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAssigneesIds(selectedAssigneesIds);
        break;
    }
  }

  setUsedSelectedCallStatusesIds(selectedCallStatusesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedCallStatusesIds(selectedCallStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedCallStatusesIds(selectedCallStatusesIds);
        break;
    }
  }

  setUsedSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds);
        break;
    }
  }

  setUsedSelectedChannelsIds(selectedChannelsIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedChannelsIds(selectedChannelsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedChannelsIds(selectedChannelsIds);
        break;
    }
  }

  setUsedSelectedCompaniesIds(selectedCompaniesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedCompaniesIds(selectedCompaniesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedCompaniesIds(selectedCompaniesIds);
        break;
    }
  }

  setUsedSelectedCommitmentsIds(selectedCommitmentsIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedCommitmentsIds(selectedCommitmentsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedCommitmentsIds(selectedCommitmentsIds);
        break;
    }
  }

  setUsedSelectedProcessesIds(selectedProcessesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedProcessesIds(selectedProcessesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedProcessesIds(selectedProcessesIds);
        break;
    }
  }

  setUsedSelectedLeadStatusesIds(selectedLeadStatusesIds: LeadStatus[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedLeadStatusesIds(selectedLeadStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedLeadStatusesIds(selectedLeadStatusesIds);
        break;
    }
  }

  setUsedSelectedPriceType(selectedPriceType: string): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedPriceType(selectedPriceType);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedPriceType(selectedPriceType);
        break;
    }
  }

  setUsedSelectedSaleStatusesIds(selectedSaleStatusesIds: LeadStatus[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedSaleStatusesIds(selectedSaleStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedSaleStatusesIds(selectedSaleStatusesIds);
        break;
    }
  }

  setUsedSelectedTags(selectedTags: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedTags(selectedTags);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedTags(selectedTags);
        break;
    }
  }

  //#endregion Setters based on page kind

  //#endregion Private methods
}

</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.dropdown-w {
  padding: 0 12px 20px;
  width: 12.5%;
  flex: 0 0 12.5%;

  @media (max-width: 1599px) {
    width: 25%;
    flex: 0 0 25%;

    @media (resolution: 120dpi) {
      width: 12.5%;
      flex: 0 0 12.5%;
    }
  }

  @media (max-width: 1279px) and (resolution: 120dpi) {
    width: 25%;
    flex: 0 0 25%;
  }

  @media (max-width: 991px) {
    width: 50%;
    flex: 0 0 50%;
    padding: 0 8px 15px;
  }

  &.ad-titles-wrapper {
    display: flex;
    .b-tooltip{
      @media (max-width: 991px) {
        display: none;
      }
    }
  }



  .b-tooltip {
    color: #aaa;
    margin-right: 0;
    display: block;
  }

  .dropdown {
    width: 100%;

    .dropdown-item-with-icon {
      display: flex;

      .icon-w {
        display: flex;
        margin-inline-end: 0.5rem;
        min-width: 22px;

        img {
          max-height: 22px;
          min-width: 22px;
          width: 22px;
        }
      }
    }

    .dropdown-trigger {
      width: 100%;

      .button {
        width: 100%;
      }
    }
  }
}

html[dir="rtl"] {
  .dropdown-w {
    .b-tooltip {
      margin-left: 0;
      margin-right: .2rem;
    }
  }
}
</style>
